import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VListGroup,{attrs:{"prepend-icon":_vm.icon},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c(VListItemTitle,[_vm._v(_vm._s(_vm.title))])]},proxy:true}])},_vm._l((_vm.items),function(item){return _c(VListItem,{key:item.text},[_c('MenuItem',{attrs:{"item":item}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }